import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Localization from '../../utils/localization';
import { locales } from '../../config/localesConfig';

const useLanguageSettings = () => {
    const { i18n } = useTranslation();
    const suportedLanguages = Localization.getCountrySupportedLanguageOptions();
    const languageInfoFromStoredLocaleValue = useMemo(
        () =>
            suportedLanguages.find(
                (language) => language.value === localStorage.getItem('languageOption')
            ),
        []
    );
    const defaultLanguage = useMemo(
        () =>
            !languageInfoFromStoredLocaleValue
                ? {
                      value: Localization.getPrimaryLocale(),
                      dir: locales[Localization.getPrimaryLocale()].rtl ? 'rtl' : 'ltr'
                  }
                : languageInfoFromStoredLocaleValue,
        []
    );

    const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);

    useEffect(() => {
        document.getElementById('root').dir = selectedLanguage.dir;
        i18n.changeLanguage(selectedLanguage.value).then(() =>
            localStorage.setItem('languageOption', selectedLanguage.value)
        );
    }, [selectedLanguage]);

    return {
        selectedLanguage,
        setSelectedLanguage,
        suportedLanguages
    };
};

export default useLanguageSettings;
